// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\">Being a Responsible Borrower Starts Here </h2> ";
// Exports
export default code;